import styled from "styled-components";

export default styled.div.attrs({ className: "container mx-auto" })``;
